import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Course, CourseValue } from '../models';

export const courseActions = createActionGroup({
    source: 'Course',
    events: {
        'Get Course': props<{ id: string }>(),
        'Get Course Success': props<{ payload: Course }>(),
        'Get Course Error': props<{ code: number }>(),
        'Create Course': props<{ value: CourseValue }>(),
        'Create Course Success': props<{ payload: Course }>(),
        'Create Course Error': props<{ code: number }>(),
        'Update Course': props<{ id: string; value: CourseValue }>(),
        'Update Course Success': props<{ payload: Course }>(),
        'Update Course Error': props<{ code: number }>(),
        'Delete Course': props<{ id: string }>(),
        'Delete Course Success': props<{ id: string }>(),
        'Delete Course Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
